import { Component, OnInit, signal } from '@angular/core';
import { HELP_HEAD_TO_HEAD } from '../app.constants';
import { HelpService } from '../shared/service/help.service';
import { Router } from '@angular/router';
import { AlertService } from '../shared/alert/alert.service';
import { ParamContext } from '../shared/service/param.context';

@Component({
    selector: 'jhi-head-to-head-query',
    templateUrl: './head-to-head-query.component.html',
    styleUrls: [
        './head-to-head-query.component.scss'
    ]
})
export class HeadToHeadQueryComponent implements OnInit {

    helpLink: string;
    step = signal(0);

    constructor(private helpService: HelpService,
                private router: Router,
                private alertService: AlertService,
                private paramContext: ParamContext,) {
        this.paramContext.readParams();
    }

    ngOnInit() {
        if (!this.helpLink || !this.helpLink.length) {
            this.helpService.getHelpLink(HELP_HEAD_TO_HEAD).toPromise().then((response) => {
                this.helpLink = response.body;
            }).catch((error) => {});
        }
    }

    setStep(index: number) {
        this.step.set(index);
    }

    nextStep() {
        this.step.update(i => i + 1);
    }

    prevStep() {
        this.step.update(i => i - 1);
    }

}